<div *ngIf="examSharingService.showCloseTabText; else loading" class="modal__wrapper flex--center flex--col">
  <div class="heading-18 u-mb--">{{ 'collaboration.openlink.closeTabTitle' | translate }}</div>
  <div class="heading-16 u-mb--">{{ 'collaboration.openlink.closeTabMessage' | translate }}</div>
</div>
<ng-template #loading>
  <div class="modal__wrapper flex--center flex--col">
    <div class="heading-18 u-mb+">{{ 'collaboration.openlink.landingPageTitle' | translate }}</div>
    <wfm-spinner [show]="true" [size]="250"></wfm-spinner>
  </div>
</ng-template>
